export * from './stores.component';
